import { Badge, Text } from '@mantine/core';

export interface IntervalTagViewProps {
  intervalId: number | string;
  startDate: string | Date;
  endDate: string | Date;
  /** Mantine color name (e.g. a resource's category color) or a hex value. Defaults to gray. */
  color?: string;
  size?: 'xs' | 'sm' | 'md';
}

const RANGE_FORMATTER = new Intl.DateTimeFormat('da-DK', { day: 'numeric', month: 'short' });

function formatRange(start: string | Date, end: string | Date) {
  const s = RANGE_FORMATTER.format(new Date(start));
  const e = RANGE_FORMATTER.format(new Date(end));
  return s === e ? s : `${s} – ${e}`;
}

export function IntervalTagView({
  intervalId,
  startDate,
  endDate,
  color = 'gray',
  size = 'sm',
}: IntervalTagViewProps) {
  return (
    <Badge variant="light" color={color} radius="sm" size={size} style={{ textTransform: 'none' }}>
      <Text span fw={700} inherit>
        #I-{intervalId}
      </Text>{' '}
      <Text span inherit c="dimmed">
        {formatRange(startDate, endDate)}
      </Text>
    </Badge>
  );
}
